<template>
  <li
    data-sidebar="menu-item"
    :class="cn('tw:group/menu-item tw:relative', props.class)"
  >
    <slot />
  </li>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
